import React, { useState, useEffect } from "react";
/* eslint-disable jsx-a11y/interactive-supports-focus */
import PropTypes from "prop-types";
// import { Link } from "react-router-dom";

import getUmbracoMedia from "../api/getUmbracoMedia";
import { focalPointToAnchor } from "../helpers/focalPoint";

import formatDate from "../helpers/formatDate";
// import extractExcerpt from "../helpers/extractExcerpt";

const ContentCard = ({
  name,
  id,
  image,
  imageId,
  publishDate,
  introductionText,
  blogroute,
  blogurl,
}) => {
  const [altText, setAltText] = useState("");
  const [focalAnchor, setFocalAnchor] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchAlt = async () => {
      if (!imageId) return;
      try {
        const media = await getUmbracoMedia(imageId);
        if (cancelled || !media) return;
        // Try a few common fields for alt text, fall back to media name or empty string
        const alt =
          media?.altText ||
          media?.properties?.alt ||
          media?.properties?.altText ||
          media?.name ||
          media?.fileName ||
          "";
        setAltText(alt);

        // Use helper to convert any focalPoint shape into an anchor string
        const rawFp =
          media?.focalPoint || media?.properties?.focalPoint || media?.properties?.focusPoint || media?.properties?.focal || media?.meta?.focalPoint || null;
        const anchor = focalPointToAnchor(rawFp);
        setFocalAnchor(anchor);
      } catch (e) {
        // ignore errors — keep altText as empty string
      }
    };

    fetchAlt();
    return () => {
      cancelled = true;
    };
  }, [imageId]);
  const Component = ({ value }) => {
    return <div>{value}</div>;
  };

  return (
    <>
      <article className="wmcads-content-card wmcads-content-card--news">
        {image !== "No Image" ? (
          <div
            className="wmcads-image-wrapper"
            style={{
              position: "relative",
              width: "100%",
              maxWidth: 600,
              marginTop: 16,
              // Reserve space using aspect ratio (600x250)
              paddingBottom: "41.666667%",
              overflow: "hidden",
            }}
          >
            {!imgLoaded && !imgError ? (
              <div
                className="wmcads-loader wmcads-loader--small"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                }}
              />
            ) : null}

            <img
              src={`https://cms.wmca.org.uk${image}?anchor=${focalAnchor || "center"}&mode=crop&width=600&height=250`}
              alt={altText || name || ""}
              className="wmcads-m-t-md"
              loading="lazy"
              decoding="async"
              onLoad={() => setImgLoaded(true)}
              onError={() => setImgError(true)}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transition: "opacity 300ms ease",
                opacity: imgLoaded ? 1 : 0,
                ...(focalAnchor
                  ? (() => {
                      const parts = (focalAnchor || "0,0").split(",");
                      const x = Math.round(parseFloat(parts[0]) * 100);
                      const y = Math.round(parseFloat(parts[1]) * 100);
                      return { objectPosition: `${x}% ${y}%` };
                    })()
                  : {}),
              }}
            />
          </div>
        ) : null}
        <p>{formatDate(publishDate)}</p>
        <h3>
          <a href={blogurl + blogroute}>{name}</a>
        </h3>
        <Component
          value={
            introductionText?.length > 10
              ? introductionText.substring(0, 200) + "..."
              : introductionText
          }
        />
      </article>
    </>
  );
};

ContentCard.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  publishDate: PropTypes.string.isRequired,
  introductionText: PropTypes.string,
  blogroute: PropTypes.string.isRequired,
  blogurl: PropTypes.string.isRequired,
};

export default ContentCard;
